import React from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { LoginScreen, ResetPassword } from '@paragon/login-tools';

export function ServicesResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const initialEmail = params.get('email');

  function afterSuccessfulPasswordSet() {
    navigate('/', { replace: true });
  }

  return (
    <LoginScreen>
      <ResetPassword initialEmail={initialEmail ?? undefined} onSuccessfulReset={afterSuccessfulPasswordSet} />
    </LoginScreen>
  );
}
